var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames", "../../UI/Icon/Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"), require("../../UI/Icon/Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Icon);
    global.ProgramExternalLinks = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames, _Icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _Icon = _interopRequireDefault(_Icon);

  var ProgramExternalLinks = function ProgramExternalLinks(_ref) {
    var links = _ref.links,
        className = _ref.className;
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: (0, _classnames.default)('next-external-links', className)
    }, links.map(function (_ref2) {
      var _ref2$iconName = _ref2.iconName,
          iconName = _ref2$iconName === void 0 ? 'arte-next-external-link' : _ref2$iconName,
          _ref2$iconSize = _ref2.iconSize,
          iconSize = _ref2$iconSize === void 0 ? 'xxsmall' : _ref2$iconSize,
          label = _ref2.label,
          url = _ref2.url;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "link-".concat(url),
        className: "next-external-links__item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "next-external-links__link",
        href: url
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "next-external-links__border"
      }, iconName && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: "next-external-links__icon",
        name: iconName,
        size: iconSize
      }), label)));
    }));
  };

  ProgramExternalLinks.propTypes = {
    className: _propTypes.default.string,
    links: _propTypes.default.arrayOf(_propTypes.default.shape({
      iconName: _propTypes.default.string,
      iconSize: _propTypes.default.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'custom']),
      label: _propTypes.default.string.isRequired,
      url: _propTypes.default.string.isRequired
    })).isRequired
  };
  ProgramExternalLinks.defaultProps = {
    className: '',
    links: []
  };
  var _default = ProgramExternalLinks;
  _exports.default = _default;
});